/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
let t;function e(){t=void 0}function n(e){return t&&!t.destroyed||(t=e()),t}export{e as clearDefaultPortalInstance,n as ensureDefaultPortalInstance};
